"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupValue = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var LookupValue = /** @class */ (function (_super) {
    __extends(LookupValue, _super);
    function LookupValue(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            lookupValue: ""
        };
        return _this;
    }
    LookupValue.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, id = _a.id, type = _a.type;
        if (id && type) {
            this.lookupService.fetchLookupValues(type, "en-UK").subscribe(function (lookupValues) {
                var _a, _b;
                var lookupValue = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === String(id); })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
                _this.setState({
                    lookupValue: lookupValue
                });
            });
        }
    };
    LookupValue.prototype.render = function () {
        return this.state.lookupValue;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconLookupService),
        __metadata("design:type", Object)
    ], LookupValue.prototype, "lookupService", void 0);
    return LookupValue;
}(React.Component));
exports.LookupValue = LookupValue;
//# sourceMappingURL=LookupValue.js.map